// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-image-wrapper[data-v-3da141f6] {
  display: flex;
  position: relative;
  width: 100%;
  height: 100%;
  min-width: 100px;
  min-height: 38px;
  border-radius: 10px;
  overflow: hidden;
  flex-direction: column;
  margin-bottom: 0.65rem;
}
.chat-image-wrapper[data-v-3da141f6] .loader {
  background: none;
}
.chat-image-wrapper .fwd[data-v-3da141f6] {
  font-size: .9em;
  display: flex;
  flex-direction: column;
  color: var(--fwd-message-color);
  margin-bottom: 0.33em;
  z-index: 1;
}
.chat-image-wrapper .fwd.side-left[data-v-3da141f6] {
  background-color: var(--message-left-bgcolor);
}
.chat-image-wrapper .fwd.side-right[data-v-3da141f6] {
  background-color: var(--message-right-bgcolor);
}
.chat-image-wrapper .fwd.title[data-v-3da141f6] {
  display: flex;
  flex-direction: row;
  height: 1em;
  margin-bottom: 0.4em;
}
.chat-image-wrapper .fwd.title i[data-v-3da141f6] {
  margin-top: 0.4em;
  margin-right: 0.2em;
}
.chat-image-wrapper .blur-block[data-v-3da141f6] {
  position: absolute;
  overflow: hidden;
  object-fit: cover;
  height: 100%;
  width: 100%;
  filter: blur(4px);
}
.chat-image-wrapper .chat-image-message[data-v-3da141f6] {
  position: relative;
  cursor: pointer;
  margin: auto;
}
.chat-image-wrapper .chat-image-message .preview-block[data-v-3da141f6] {
  display: flex;
  max-width: var(--preview-block-max-width);
  max-height: var(--preview-block-max-height);
}
.chat-image-wrapper .chat-image-message .img-wrapper[data-v-3da141f6] {
  display: flex;
  overflow: hidden;
  height: 100%;
  margin: auto;
  flex-direction: column;
  border-radius: 10px;
}
.chat-image-wrapper .chat-image-message .img-wrapper img[data-v-3da141f6] {
  width: var(--image-width);
  height: var(--image-height);
  max-width: min(100%, var(--image-width));
  max-height: min(400, var(--image-height));
  object-fit: contain;
}
.chat-image-wrapper .chat-image-message .img-wrapper .failed-img-load[data-v-3da141f6] {
  position: absolute;
  display: flex;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(0deg, var(--message-right-bgcolor) 0%, var(--bg-color2) 45%);
  z-index: 99;
}
.chat-image-wrapper .chat-image-message .img-wrapper .failed-img-load .icon-wrapper[data-v-3da141f6] {
  margin: auto;
  font-size: 3em;
  color: var(--elem-grey-color);
}
`, "",{"version":3,"sources":["webpack://./js/app/components/chat/ChatImageMessage.vue"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;AACxB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,+BAA+B;EAC/B,qBAAqB;EACrB,UAAU;AACZ;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,8CAA8C;AAChD;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;AACA;EACE,aAAa;EACb,yCAAyC;EACzC,2CAA2C;AAC7C;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,wCAAwC;EACxC,yCAAyC;EACzC,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,wFAAwF;EACxF,WAAW;AACb;AACA;EACE,YAAY;EACZ,cAAc;EACd,6BAA6B;AAC/B","sourcesContent":[".chat-image-wrapper[data-v-3da141f6] {\n  display: flex;\n  position: relative;\n  width: 100%;\n  height: 100%;\n  min-width: 100px;\n  min-height: 38px;\n  border-radius: 10px;\n  overflow: hidden;\n  flex-direction: column;\n  margin-bottom: 0.65rem;\n}\n.chat-image-wrapper[data-v-3da141f6] .loader {\n  background: none;\n}\n.chat-image-wrapper .fwd[data-v-3da141f6] {\n  font-size: .9em;\n  display: flex;\n  flex-direction: column;\n  color: var(--fwd-message-color);\n  margin-bottom: 0.33em;\n  z-index: 1;\n}\n.chat-image-wrapper .fwd.side-left[data-v-3da141f6] {\n  background-color: var(--message-left-bgcolor);\n}\n.chat-image-wrapper .fwd.side-right[data-v-3da141f6] {\n  background-color: var(--message-right-bgcolor);\n}\n.chat-image-wrapper .fwd.title[data-v-3da141f6] {\n  display: flex;\n  flex-direction: row;\n  height: 1em;\n  margin-bottom: 0.4em;\n}\n.chat-image-wrapper .fwd.title i[data-v-3da141f6] {\n  margin-top: 0.4em;\n  margin-right: 0.2em;\n}\n.chat-image-wrapper .blur-block[data-v-3da141f6] {\n  position: absolute;\n  overflow: hidden;\n  object-fit: cover;\n  height: 100%;\n  width: 100%;\n  filter: blur(4px);\n}\n.chat-image-wrapper .chat-image-message[data-v-3da141f6] {\n  position: relative;\n  cursor: pointer;\n  margin: auto;\n}\n.chat-image-wrapper .chat-image-message .preview-block[data-v-3da141f6] {\n  display: flex;\n  max-width: var(--preview-block-max-width);\n  max-height: var(--preview-block-max-height);\n}\n.chat-image-wrapper .chat-image-message .img-wrapper[data-v-3da141f6] {\n  display: flex;\n  overflow: hidden;\n  height: 100%;\n  margin: auto;\n  flex-direction: column;\n  border-radius: 10px;\n}\n.chat-image-wrapper .chat-image-message .img-wrapper img[data-v-3da141f6] {\n  width: var(--image-width);\n  height: var(--image-height);\n  max-width: min(100%, var(--image-width));\n  max-height: min(400, var(--image-height));\n  object-fit: contain;\n}\n.chat-image-wrapper .chat-image-message .img-wrapper .failed-img-load[data-v-3da141f6] {\n  position: absolute;\n  display: flex;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(0deg, var(--message-right-bgcolor) 0%, var(--bg-color2) 45%);\n  z-index: 99;\n}\n.chat-image-wrapper .chat-image-message .img-wrapper .failed-img-load .icon-wrapper[data-v-3da141f6] {\n  margin: auto;\n  font-size: 3em;\n  color: var(--elem-grey-color);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
